import React from 'react'
import {
  Button,
  Form,
  Row,
  Col,
  Table
} from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleDown, faArrowCircleUp, faEye, faRedoAlt, faUsers, faTrash } from '@fortawesome/pro-solid-svg-icons'
import PaginationComponent from '../../../components/Pagination'
import useAllUserListing from './useAllUserListing'
import Trigger from '../../../components/OverlayTrigger'
import ClientFilter from '../../../components/ClientFilter'
import PortalFilter from '../../../components/PortalFilter'
import { accountStatus, kycLabels, playerTypes, tableHeaders } from './userConstant'
import DateRangePicker from '../../../components/DateRangePicker'
import { formatDateYMD, getDateTime } from '../../../utils/dateFormatter'
import { countryCode } from '../../../utils/countryJson'
import { countryFilter } from '../../../utils/countryFilter'
import { userDisableReasons } from '../UserDetails/constants'
import { getLabelByValue } from '../../../utils/helpers'
import ConfirmationModal from '../../../shared/ConfirmationModal'

export default ({ isTenant = false }) => {
  const {
    limit,
    setLimit,
    page,
    setPage,
    search,
    setSearch,
    userData,
    totalPages,
    navigate,
    affiliateSearch,
    setAffiliateSearch,
    selectedClient,
    selectedPortal,
    setSelectedPortal,
    setSelectedClient,
    loading,
    kycOptions,
    setKycOptions,
    selectedAccountStatus,
    setSelectedAccountStatus,
    state,
    setState,
    userId,
    setUserId,
    setSortBy,
    setOrderBy,
    over,
    setOver,
    selected,
    sortBy,
    regState,
    setRegState,
    setIsInternal,
    isInternal,
    setIsStreamer,
    isStreamer,
    countries,
    setSelectedCountry,
    selectedCountry,
    regPlayerDate,
    setRegPlayerDate,
    regPlayersType,
    setRegPlayersType,
    licenseList,
    selectedLicense,
    setSelectedLicense,
    isDeleteUserModalVisible,
    setIsDeleteUserModalVisible,
    selectedUserForDeletion,
    setSelectedUserForDeletion,
    processUserDeletion,
    isHidden
  } = useAllUserListing({ isTenant, restrict: false })

  const allAccountAndDisableOptions = [...accountStatus, ...userDisableReasons]
  return (
    <>
      <Row>
        <Col>
          <Row>
            <h3><FontAwesomeIcon icon={faUsers} />&nbsp;Players</h3>
          </Row>
        </Col>
      </Row>

      <Row xs='auto'>
        {!isTenant &&
          <Col className='d-flex align-self-center mt-2'>
            <ClientFilter
              setSelectedClient={setSelectedClient}
              setSelectedPortal={setSelectedPortal}
              selectedClient={selectedClient}
            />

            {selectedClient && (
              <PortalFilter
                setSelectedPortal={setSelectedPortal}
                selectedPortal={selectedPortal}
                selectedClient={selectedClient}
              />
            )}
          </Col>}
        <Col className='d-flex align-self-center mt-2'>
          <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            License
          </Form.Label>
          <Form.Select
            size='sm'
            style={{ maxWidth: '230px' }}
            value={selectedLicense}
            onChange={e =>
              setSelectedLicense(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
          >
            <option value=''>Select a License</option>
            {licenseList?.length > 0 && licenseList.map(({ name, id }) => (
              <option key={id} value={id}>{name}</option>
            ))}
          </Form.Select>
        </Col>

        <Col className='d-flex align-self-center mt-2'>
          <Form.Label className='mx-auto text-nowrap align-self-center' style={{ paddingRight: '10px', marginBottom: '0' }}>
            Date of Birth
          </Form.Label>
          <DateRangePicker state={state} setState={setState} player transaction bonus max={formatDateYMD(new Date())} />
        </Col>
        <Col className='d-flex align-self-center mt-2'>
          <Form.Label style={{ marginBottom: '0', marginRight: '15px', marginTop: '5px' }}>
            Search
          </Form.Label>

          <Form.Control
            type='search'
            placeholder='Search Username, Email'
            size='sm'
            style={{ width: '230px', marginRight: '10px', maxHeight: '15px' }}
            value={search}
            onChange={(event) =>
              setSearch(
                event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, '')
              )}
          />
        </Col>

        <Col className='d-flex mt-2'>
          <Form.Label style={{ marginBottom: '0', marginTop: '5px', minWidth: '90px' }}>
            Affiliate Name
          </Form.Label>

          <Form.Control
            type='search'
            placeholder='Search Affiliate'
            size='sm'
            style={{ width: '230px', marginRight: '10px', maxHeight: '15px' }}
            value={affiliateSearch}
            onChange={(event) =>
              setAffiliateSearch(event.target.value)}
          />
        </Col>

        <Col className='d-flex mt-2'>
          <Form.Label style={{ marginBottom: '0', marginRight: '15px', marginTop: '5px', minWidth: '90px' }}>
            Search By UserId
          </Form.Label>

          <Form.Control
            type='number'
            placeholder='Search UserId'
            size='sm'
            style={{ width: '230px', marginRight: '10px', maxHeight: '15px' }}
            value={userId}
            onChange={(event) =>
              setUserId(event.target.value)}
          />
        </Col>
        <Col className='d-flex align-self-center mt-2'>
          <Form.Label style={{ marginBottom: '0', marginRight: '15px', marginTop: '5px' }}>
            Status
          </Form.Label>
          <Form.Select
            onChange={(e) => {
              setSelectedAccountStatus(e.target.value)
            }}
            value={selectedAccountStatus}
            style={{ maxWidth: '180px', marginRight: '10px', height: '36px' }}
            size='sm'
          >
            {allAccountAndDisableOptions.map((item) => {
              return <option key={`kyc Levels ${item.value}`} value={item.value}>{item.label}</option>
            })}

          </Form.Select>
        </Col>

        <Col className='d-flex mt-2'>
          <Form.Label style={{ marginBottom: '0', marginTop: '5px', minWidth: '70px' }}>
            KYC Status
          </Form.Label>
          <Form.Select
            onChange={(e) => setKycOptions(e.target.value)}
            value={kycOptions}
            style={{ maxWidth: '180px', marginRight: '10px', height: '36px' }}
            size='sm'
          >
            {kycLabels.map((item, index) => {
              return <option key={index} value={item.value}>{item.label}</option>
            })}

          </Form.Select>
        </Col>

        <Col className='d-flex align-self-center'>
          <Form.Label style={{ paddingRight: '10px', marginBottom: '0' }}>
            Is Internal
          </Form.Label>
          <Form.Switch
            name='isInternal'
            checked={isInternal}
            onChange={() => setIsInternal(!isInternal)}
          />
        </Col>

        <Col className='d-flex align-self-center'>
          <Form.Label style={{ paddingRight: '10px', marginBottom: '0' }}>
            Is Streamer
          </Form.Label>
          <Form.Switch
            name='isStreamer'
            checked={isStreamer}
            onChange={() => setIsStreamer(!isStreamer)}
          />
        </Col>

        <Col className='d-flex align-self-center mt-2'>
          <Form.Label style={{ marginBottom: '0', marginTop: '5px', minWidth: '80px' }}>
            Player Type
          </Form.Label>
          <Form.Select
            onChange={(e) => setRegPlayersType(e.target.value)}
            value={regPlayersType}
            style={{ maxWidth: '180px', marginRight: '10px', height: '36px' }}
            size='sm'
          >
            {playerTypes.map((item) => <option key={`players-type ${item.value}`} value={item.value}>{item.label}</option>)}
          </Form.Select>
        </Col>

        {regPlayersType === 'newDepositors'
          ? (
            <Col className='d-flex mt-2 d-flex align-self-center'>
              <Form.Label className='mx-auto text-nowrap align-self-center' style={{ paddingRight: '10px', marginBottom: '0' }}>
                First Depositors
              </Form.Label>
              <DateRangePicker state={regPlayerDate} setState={setRegPlayerDate} player />
            </Col>)
          : (
            <Col className='d-flex mt-2'>
              <Form.Label className='mx-auto text-nowrap align-self-center' style={{ paddingRight: '10px', marginBottom: '0' }}>
                Registration Date
              </Form.Label>
              <DateRangePicker state={regState} setState={setRegState} player transaction bonus reg />
            </Col>)}

        {(countries && Array.isArray(countries)) &&
          <Col className='d-flex align-self-center mt-2'>
            <Form.Label style={{ marginBottom: '0', marginTop: '5px', minWidth: '70px' }}>
              Country
            </Form.Label>
            <Form.Select
              onChange={(e) => setSelectedCountry(countryCode.find(val => val.name === e.target.value)?.code)}
              value={countries?.find(({ code }) => code === selectedCountry)?.name?.EN || ''}
              style={{ maxWidth: '180px', marginRight: '10px' }}
              size='sm'
            >
              <option value=''>Select Country</option>
              {countries?.map((item, idx) => {
                return <option key={`country names2 ${idx}`} value={item.name?.EN}>{item.name?.EN}</option>
              })}

            </Form.Select>
          </Col>}

        <Col className='d-flex mt-2'>
          <Trigger message='Reset Filters'>
            <Button
              variant='outline-success'
              className='align-self-center'
              size='sm'
              onClick={() => {
                setSearch('')
                setAffiliateSearch('')
                setUserId('')
                setLimit(15)
                setPage(1)
                setOrderBy('userId')
                setSortBy('desc')
                setKycOptions('')
                setIsInternal(false)
                setSelectedCountry('')
                setState([
                  {
                    startDate: new Date('01 July 1923'),
                    endDate: new Date(),
                    key: 'selection'
                  }
                ])
                setRegState([
                  {
                    startDate: new Date('01 July 1923'),
                    endDate: new Date(),
                    key: 'selection'
                  }
                ])
                setIsInternal(false)
              }}
            >
              <FontAwesomeIcon icon={faRedoAlt} />
            </Button>
          </Trigger>
        </Col>
      </Row>

      <Table bordered striped responsive hover size='sm' className='text-center mt-4'>
        <thead className='thead-dark'>
          <tr>
            {tableHeaders.map((h, idx) => (
              <th
                key={idx}
                onClick={() => (h.value === 'email' || h.value === 'userId' || h.value === 'username') && setOrderBy(h.value)}
                style={{
                  cursor: 'pointer'
                }}
              >
                {h.label}{' '}
                {selected(h) &&
                  (sortBy === 'asc'
                    ? (
                      <FontAwesomeIcon
                        style={over ? { color: 'red' } : {}}
                        icon={faArrowCircleUp}
                        onClick={() => setSortBy('desc')}
                        onMouseOver={() => setOver(true)}
                        onMouseLeave={() => setOver(false)}
                      />
                      )
                    : (
                      <FontAwesomeIcon
                        style={over ? { color: 'red' } : {}}
                        icon={faArrowCircleDown}
                        onClick={() => setSortBy('asc')}
                        onMouseOver={() => setOver(true)}
                        onMouseLeave={() => setOver(false)}
                      />
                      ))}
              </th>
            ))}
          </tr>
        </thead>

        <tbody id={loading ? 'cover-spin' : ''}>
          {!loading && Boolean(userData) &&
            userData?.rows?.map(
              (playerDetails) => {
                const {
                  status, userId, kycStatus,
                  affiliate, sumsubKycStatus, kycMethod, username,
                  userWallet, createdAt, countryCode, pendingWithdrawalAmount,
                  totalWithdrawalAmount, currencyCode = 'EUR'
                } = playerDetails
                const { countryImage, countryName } = countryFilter(countryCode)
                return (
                  <tr key={userId}>
                    <td>{userId}</td>
                    <td>
                      <Trigger message={username}>
                        <span
                          style={{
                            width: '100px',
                            cursor: 'pointer'
                          }}
                          onClick={() =>
                            window.open(`/${isTenant ? 'tenant' : 'super-admin'}/users/details/${userId}`, '_blank')}
                          className='text-link d-inline-block text-truncate'
                        >
                          {username}
                        </span>
                      </Trigger>
                    </td>

                    <td>{createdAt ? getDateTime(createdAt) : 'NA'}</td>

                    <td>{`${userWallet?.amount?.toFixed(2) || 0} ${currencyCode}`}</td>

                    <td>{`${userWallet?.nonCashAmount?.toFixed(2) || 0} ${currencyCode}`}</td>

                    <td>
                      <Trigger message={countryName}>
                        <img width='25px' src={countryImage} alt={countryImage} />
                      </Trigger>
                    </td>

                    <td>{pendingWithdrawalAmount === null ? `0 ${currencyCode}` : `${pendingWithdrawalAmount || 0} ${currencyCode}`}</td>

                    <td>{totalWithdrawalAmount === null ? `0 ${currencyCode}` : `${totalWithdrawalAmount || 0} ${currencyCode}`}</td>

                    <td>
                      {status === 'true' || status === true
                        ? (
                          <span className='text-success'>Active</span>
                          )
                        : (
                          <span className='text-danger'>{status === null ? 'Temp. In-Active' : status === 'false' || status === false ? 'In Active' : getLabelByValue(allAccountAndDisableOptions, status)}</span>
                          )}
                    </td>

                    <td>{kycMethod === 1 ? (`${sumsubKycStatus?.toUpperCase()} (Sumsub)` || '-') : (`${kycStatus} (System KYC)` || '-')}</td>

                    <td>
                      {affiliate?.username || <span>NA</span>}
                    </td>
                    <td>
                      <Trigger message='View Details'>
                        <Button
                          className='m-1'
                          size='sm'
                          variant='info'
                          onClick={() => {
                            navigate(
                              `/${isTenant ? 'tenant' : 'super-admin'}/users/details/${userId}`
                            )
                          }}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                      </Trigger>
                      <Trigger message='Delete'>
                        <Button
                          className='m-1'
                          size='sm'
                          variant='danger'
                          hidden={isHidden({ module: { key: 'DisableUser', value: 'D' } })}
                          onClick={() => {
                            setSelectedUserForDeletion(playerDetails)
                            setIsDeleteUserModalVisible(true)
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </Trigger>
                    </td>
                  </tr>
                )
              }
            )}

          {userData?.count === 0 && !loading && (
            <tr>
              <td colSpan={13} className='text-danger text-center'>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {userData?.count !== 0 && !loading && (
        <PaginationComponent
          page={userData?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          totalCount={userData?.count}
        />
      )}
      {
        isDeleteUserModalVisible &&
          <ConfirmationModal
            showModal={isDeleteUserModalVisible}
            onCancel={() => setIsDeleteUserModalVisible(false)}
            onConfirm={processUserDeletion}
            confirmText='Yes'
            cancelText='No'
            bodyText={`Are you sure you want to delete ${selectedUserForDeletion?.username} ?`}
            additionalNote=''
            isLoading={false}
          />
      }

    </>
  )
}
